@if (entities.filter) {

<ui-selector [filter]="entities.filter" (selectionChanged)="close()"></ui-selector>

}